import React from 'react'
import env from 'misc/env'
import { observer } from 'mobx-react'
import Modal from 'components/Modal'
import { Dialog, DialogButton, DialogFooter } from 'components/Dialog'
import './styles.sass'

const TermsDialog = ({ state }) => {
  return (
    <Modal isOpened={state.showing} onRequestClose={() => state.decline()}>
      <Dialog className="terms-dialog">
        <div className="iframe-container">
          <iframe
            className="terms-frame"
            src={env.TAXFYLE_TERMS_URL}
            frameBorder="0"
            seamless="seamless"
          />
        </div>
        <DialogFooter className="terms-dialog__footer">
          <DialogButton onClick={() => state.accept()}>Accept</DialogButton>
          <DialogButton danger onClick={() => state.decline()}>Decline</DialogButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  )
}

export default observer(TermsDialog)



// WEBPACK FOOTER //
// ./src/client/components/TermsDialog/index.jsx